import { Banner } from "../../components/ui/Banner";
import { motion } from "framer-motion"; // Add this import
import { workExperience } from "../../data/content";

export const WorkExperienceSection = () => {
    const container = {
        hidden: { opacity: 0 },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
            },
        },
    };

    const item = {
        hidden: { opacity: 0, y: 20 },
        show: { opacity: 1, y: 0 },
    };

    return (
        <div className="flex flex-col space-y-4">
            {/* Banner */}
            <Banner title="Work Experience" />
            {/*  */}
            <motion.div
                className="flex flex-col gap-6 px-4 sm:px-10 mt-2"
                variants={container}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
            >
                {/*  */}
                {workExperience.map((work, index) => (
                    <motion.div
                        key={index}
                        className="items-center flex flex-row py-2"
                        variants={item}
                    >
                        <div className="w-12 sm:w-16 aspect-square rounded border-button border bg-background flex items-center justify-center">
                            {work.icon}
                        </div>
                        <div className="ml-3">
                            <h2>{work.company}</h2>
                            <p>{work.position}</p>
                            <p>{work.duration}</p>
                            {work.points && Array.isArray(work.points) && (
                                <ul className="list-disc ml-5 mt-2 text-sm text-muted-foreground">
                                    {work.points.map(
                                        (point: string, idx: number) => (
                                            <li key={idx}>{point}</li>
                                        ),
                                    )}
                                </ul>
                            )}
                        </div>
                    </motion.div>
                ))}
            </motion.div>
        </div>
    );
};
